module.exports = __webpack_public_path__ + "fonts/ProximaNovaACond-Light.6fcf712faa6b47d3981869f64b944832.woff";